/* eslint-disable no-unused-vars */
import React from "react";
// import ProjectCard from "./ProjectCard";
import { CodeBracketIcon, EyeIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
const projectData = [
  {
    id: "1",
    title: "Todo List App",
    description: "Project 1 description",
    image: '"../images/projects/1.png"',
    tag: ["All", "Web"],
  },
  {
    id: 2,
    title: "Coffee Masters",
    description: "Project 2 description",
    image: "../images/projects/1.png",
    tag: ["All", "Web"],
  },
  {
    id: 3,
    title: "Apple store",
    description: "Project 3 description",
    image: "../images/projects/1.png",
    tag: ["All", "Web"],
  },
  {
    id: 4,
    title: "pray app",
    description: "Project 4 description",
    image: "../images/projects/1.png",
    tag: ["All", "Web"],
  },
  {
    id: 5,
    title: "Product Management system",
    description: "Project 5 description",
    image: "../images/projects/2.png",
    tag: ["All", "Web"],
  },
];

const ProjectSection = (title, description) => {
  return (
    <>
      <h2 className="text-center text-4xl font-bold text-white mt-4  ">
        My Projects
      </h2>
      <section>
        <div className="grid md:grid-cols-3 gap-8 md:gap-12 mt-8 items-center">
          <div className="bg-cover relative">
            <img
              src={require("../images/projects/1.jpg")}
              alt=""
              className=" rounded-t-xl"
            />
            <div
              className="flex items-center justify-center absolute overlay top-0 left-0 w-full h-full bg-[#181818] bg-opacity-0 
                          hover:bg-opacity-70 rounded-xl duration-400"
            >
              <div className="h-14 w-14 mr-2 border-2 relative rounded-full border-[#ADB7BE] hover:border-white group/link">
                <CodeBracketIcon className="text-[#ADB7BE] absolute  h-10 w-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  cursor-pointer group-hover/link:text-white " />
              </div>
              <a href="https://gemy-to-do-list.vercel.app">
                <div className="h-14 w-14 border-2 relative rounded-full border-[#ADB7BE] hover:border-white group/link">
                  <EyeIcon className="text-[#ADB7BE] absolute  h-10 w-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  cursor-pointer group-hover/link:text-white " />
                </div>
              </a>
            </div>
            <div className="text-white rounded-b-xl bg-[#181818] py-6 px-4">
              <h5 className="text-xl font-semibold mb-2">Todo List App</h5>
              <p className="text-[#ADB7BE]">Project 1 </p>
            </div>
          </div>
          <div className="bg-cover relative">
            <img
              src={require("../images/projects/2.jpg")}
              alt=""
              className=" rounded-t-xl"
            />
            <div
              className="flex items-center justify-center absolute overlay top-0 left-0 w-full h-full bg-[#181818] bg-opacity-0 
              hover:flex hover:bg-opacity-70 rounded-xl duration-400"
            >
              <div className="h-14 w-14 mr-2 border-2 relative rounded-full border-[#ADB7BE] hover:border-white group/link">
                <CodeBracketIcon className="text-[#ADB7BE] absolute  h-10 w-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  cursor-pointer group-hover/link:text-white " />
              </div>
              <a href="https://coffe-master.vercel.app/">
                <div className="h-14 w-14 border-2 relative rounded-full border-[#ADB7BE] hover:border-white group/link">
                  <EyeIcon className="text-[#ADB7BE] absolute  h-10 w-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  cursor-pointer group-hover/link:text-white " />
                </div>
              </a>
            </div>
            <div className="text-white rounded-b-xl bg-[#181818] py-6 px-4">
              <h5 className="text-xl font-semibold mb-2">Coffee Masters</h5>
              <p className="text-[#ADB7BE]">Project 2 </p>
            </div>
          </div>
          <div className="bg-cover relative">
            <img
              src={require("../images/projects/3.jpg")}
              alt=""
              className=" rounded-t-xl"
            />
            <div
              className="flex items-center justify-center absolute overlay top-0 left-0 w-full h-full bg-[#181818] bg-opacity-0 
              hover:flex hover:bg-opacity-70 rounded-xl duration-400"
            >
              <div className="h-14 w-14 mr-2 border-2 relative rounded-full border-[#ADB7BE] hover:border-white group/link">
                <CodeBracketIcon className="text-[#ADB7BE] absolute  h-10 w-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  cursor-pointer group-hover/link:text-white " />
              </div>
              <a href="https://apple-app-jade.vercel.app/">
                <div className="h-14 w-14 border-2 relative rounded-full border-[#ADB7BE] hover:border-white group/link">
                  <EyeIcon className="text-[#ADB7BE] absolute  h-10 w-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  cursor-pointer group-hover/link:text-white " />
                </div>
              </a>
            </div>
            <div className="text-white rounded-b-xl bg-[#181818] py-6 px-4">
              <h5 className="text-xl font-semibold mb-2">Apple store</h5>
              <p className="text-[#ADB7BE]">Project 3 </p>
            </div>
          </div>
          <div className="bg-cover relative">
            <img
              src={require("../images/projects/4.jpg")}
              alt=""
              className=" rounded-t-xl"
            />
            <div
              className="flex items-center justify-center absolute overlay top-0 left-0 w-full h-full bg-[#181818] bg-opacity-0 
              hover:flex hover:bg-opacity-70 rounded-xl duration-400"
            >
              <div className="h-14 w-14 mr-2 border-2 relative rounded-full border-[#ADB7BE] hover:border-white group/link">
                <CodeBracketIcon className="text-[#ADB7BE] absolute  h-10 w-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  cursor-pointer group-hover/link:text-white " />
              </div>
              <a href="https://pray-time-gemy.vercel.app/">
                <div className="h-14 w-14 border-2 relative rounded-full border-[#ADB7BE] hover:border-white group/link">
                  <EyeIcon className="text-[#ADB7BE] absolute  h-10 w-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  cursor-pointer group-hover/link:text-white " />
                </div>
              </a>
            </div>
            <div className="text-white rounded-b-xl bg-[#181818] py-6 px-4">
              <h5 className="text-xl font-semibold mb-2">pray app</h5>
              <p className="text-[#ADB7BE]">Project 4 </p>
            </div>
          </div>
          <div className="bg-cover relative">
            <img
              src={require("../images/projects/5.jpg")}
              alt=""
              className=" rounded-t-xl"
            />
            <div
              className="flex items-center justify-center absolute overlay top-0 left-0 w-full h-full bg-[#181818] bg-opacity-0 
              hover:flex hover:bg-opacity-70 rounded-xl duration-400"
            >
              <div className="h-14 w-14 mr-2 border-2 relative rounded-full border-[#ADB7BE] hover:border-white group/link">
                <CodeBracketIcon className="text-[#ADB7BE] absolute  h-10 w-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  cursor-pointer group-hover/link:text-white " />
              </div>
              <a href="https://pms-ecru-mu.vercel.app/">
                <div className="h-14 w-14 border-2 relative rounded-full border-[#ADB7BE] hover:border-white group/link">
                  <EyeIcon className="text-[#ADB7BE] absolute  h-10 w-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  cursor-pointer group-hover/link:text-white " />
                </div>
              </a>
            </div>
            <div className="text-white rounded-b-xl bg-[#181818] py-6 px-4">
              <h5 className="text-xl font-semibold mb-2">
                Product Management system
              </h5>
              <p className="text-[#ADB7BE]">Project 5 </p>
            </div>
          </div>
        </div>
      </section>
      {/* <div>
        {projectData.map((element)=>(
          <div>
            <img src={element.image} alt="" />
            <h5>{element.title}</h5>
            <p>{element.description}</p>
          </div>
        ))}
      </div> */}

      {/* -------------------------------------- */}

      {/* <h2 className="text-center text-4xl font-bold text-white mt-4  ">
        My Projects
      </h2>
      <div className="grid md:grid-cols-3 gap-8 md:gap-12">
        {projectData.map((project) => (
          <ProjectCard
            key={project.id}
            title={project.title}
            description={project.description}
            imgUrl={project.image}
            tags={project}
          />
        ))}
      </div> */}
    </>
  );
};

export default ProjectSection;
